import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LlamadasService extends BaseService{
    recordName = 'cdr';

    url = `${ environment.host }/llamadas`;

    async getLlamadas( filtros : Record< string, any > ) {
        try {
            await this.updateToken();
            // this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            let url = `${this.url}/get-llamadas`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`,{ filtros }, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async getRecuperadores(){
        try {
            await this.updateToken();
            // this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            let url = `${this.url}/recuperadores`;
            const resp = await lastValueFrom( this.http.get<any>(`${url}`, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
}
